import { addTelemetryError } from '../domain/telemetry';
import { monitor } from '../tools/monitor';
export function createHttpRequest(endpointBuilder, bytesLimit) {
    function sendBeaconStrategy(data, bytesCount) {
        var url = endpointBuilder.build();
        var canUseBeacon = !!navigator.sendBeacon && bytesCount < bytesLimit;
        if (canUseBeacon) {
            try {
                var isQueued = navigator.sendBeacon(url, data);
                if (isQueued) {
                    return;
                }
            }
            catch (e) {
                reportBeaconError(e);
            }
        }
        sendXHR(url, data);
    }
    function fetchKeepAliveStrategy(data, bytesCount) {
        var url = endpointBuilder.build();
        var canUseKeepAlive = isKeepAliveSupported() && bytesCount < bytesLimit;
        if (canUseKeepAlive) {
            fetch(url, { method: 'POST', body: data, keepalive: true }).catch(monitor(function () {
                // failed to queue the request
                sendXHR(url, data);
            }));
        }
        else {
            sendXHR(url, data);
        }
    }
    function isKeepAliveSupported() {
        // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
        try {
            return window.Request && 'keepalive' in new Request('http://a');
        }
        catch (_a) {
            return false;
        }
    }
    function sendXHR(url, data) {
        var request = new XMLHttpRequest();
        request.open('POST', url, true);
        request.send(data);
    }
    return {
        send: function (data, bytesCount) {
            fetchKeepAliveStrategy(data, bytesCount);
        },
        /**
         * Since fetch keepalive behaves like regular fetch on Firefox,
         * keep using sendBeaconStrategy on exit
         */
        sendOnExit: sendBeaconStrategy,
    };
}
var hasReportedBeaconError = false;
function reportBeaconError(e) {
    if (!hasReportedBeaconError) {
        hasReportedBeaconError = true;
        addTelemetryError(e);
    }
}
//# sourceMappingURL=httpRequest.js.map